module.exports = __webpack_public_path__ + "images/nirvana/glyphicons-halflings-white.png";